import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from 'vue';
import VueAMap from 'vue-amap'; //注意不要和 AMap原始名称覆盖

Vue.use(VueAMap); // 初始化vue-amap

VueAMap.initAMapApiLoader({
  // 高德的key
  key: '44641f38739649861c9d7d31f69b4ac2',
  // 插件集合
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation'],
  v: '1.4.4'
});
var amapManager = new VueAMap.AMapManager();
import { //   queryinletList,
//   querySewageOutletList,
//   querySiteList,
//   querySiteIdsList,
//   querySewageAoList,
//   queryPipeSystem,
//   querySiteById,
querySiteBySt, mainRealtime as _mainRealtime, querySiteList as _querySiteList //   queryOnlineById,
} from '@/api/api';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { getAction } from '@/api/manage';
var options = [{
  label: '地表水',
  value: '21'
}, {
  label: '气象站',
  value: '22'
}, {
  label: '污水站',
  value: '52'
}, {
  label: '流域调水工况',
  value: '53'
}];
export default {
  components: {},
  mixins: [GetSiteIdMixin],
  data: function data() {
    return {
      inletStatus: '',
      outletStatus: '',
      loading: false,
      dataSource: [],
      online: '1',
      amapManager: amapManager,
      options: options,
      type: ['21', '22', '52', '53'],
      zoom: 12,
      center: [120.761164, 29.916027],
      mapStyle: 'amap://styles/dark',
      //设置地图样式
      plugin: [{
        pName: 'MapType',
        defaultType: 1,
        showRoad: false,
        showTraffic: false,
        events: {
          init: function init(o) {
            console.log(o);
          }
        }
      }],
      lines: [],
      markers: [],
      windows: [],
      window: '',
      // 表头
      columns: [],
      url: {
        list: '/oms/st52/sewage/api/water/latest'
      },
      siteInfo: {},
      imgSrc: "",
      imgSrc2: "",
      imgSrc3: "",
      imgSrc4: "",
      imgSrc5: "",
      imgSrc6: ""
    };
  },
  created: function created() {
    this.getSite('21,22,52,53');
    this.querySiteList('7');
    this.querySiteList('8');
    this.querySiteList('12');
    this.querySiteList('10');
    this.querySiteList('9');
    this.querySiteList('11');
  },
  methods: {
    querySiteList: function querySiteList(id) {
      var _this = this;

      var that = this; // 污水站点

      _querySiteList({
        id: id
      }).then(function (res) {
        if (res) {
          if (id == '8') {
            _this.remark = res.result.records[0].remarkll;
            _this.imgSrc = location.origin + '/env/sys/common/file/view/' + res.result.records[0].photo;
          } else if (id == '12') {
            _this.remark2 = res.result.records[0].remark;
            _this.imgSrc2 = location.origin + '/env/sys/common/file/view/' + res.result.records[0].photo;
          } else if (id == '7') {
            _this.remark3 = res.result.records[0].remark;
            _this.imgSrc3 = location.origin + '/env/sys/common/file/view/' + res.result.records[0].photo;
          } else if (id == '10') {
            _this.remark = res.result.records[0].remark;
            _this.imgSrc4 = location.origin + '/env/sys/common/file/view/' + res.result.records[0].photo;
          } else if (id == '9') {
            _this.remark5 = res.result.records[0].remark;
            _this.imgSrc5 = location.origin + '/env/sys/common/file/view/' + res.result.records[0].photo;
          } else if (id == '11') {
            _this.remark6 = res.result.records[0].remark;
            _this.imgSrc6 = location.origin + '/env/sys/common/file/view/' + res.result.records[0].photo;
          }
        }
      });
    },
    mainRealtime: function mainRealtime(id) {
      var _this2 = this;

      var that = this;
      this.columns = [];

      _mainRealtime({
        siteId: id
      }).then(function (res) {
        res.result.factorMap.all.forEach(function (e, i) {
          _this2.columns.push({
            title: e.title,
            align: 'center',
            width: '100px',
            dataIndex: e.code,
            customRender: function customRender(text, record, index) {
              return that.renderCol(e.code, text, record);
            }
          });
        });
        _this2.dataSource = res.result.records;
      });
    },
    // 渲染列
    renderCol: function renderCol(code, text, record) {
      var h = this.$createElement;
      var data = record.dataMap[code] || {
        value: ''
      };

      if (data.status == '2') {
        return h("span", {
          "class": "redText",
          "attrs": {
            "title": '原始数据： ' + data.raw
          }
        }, [data.value, h("a-icon", {
          "attrs": {
            "type": "arrow-down"
          },
          "style": "float:right"
        })]);
      } else if (data.status == '3') {
        return h("span", {
          "class": "redText",
          "attrs": {
            "title": '原始数据： ' + data.raw
          }
        }, [data.value, h("a-icon", {
          "attrs": {
            "type": "arrow-up"
          },
          "style": "float:right"
        })]);
      } else {
        return h("span", {
          "attrs": {
            "title": '原始数据： ' + data.raw
          }
        }, [data.value]);
      }
    },
    getStatus: function getStatus(value) {
      var h = this.$createElement;
      var status = '';

      switch (value) {
        case 1:
          status = '达标';
          break;

        case 2:
          status = h("a-icon", {
            "attrs": {
              "type": "arrow-down"
            }
          });
          break;

        case 3:
          status = h("a-icon", {
            "attrs": {
              "type": "arrow-up"
            }
          });
          break;
      }

      return status;
    },
    queryOnlineById: function (_queryOnlineById) {
      function queryOnlineById(_x) {
        return _queryOnlineById.apply(this, arguments);
      }

      queryOnlineById.toString = function () {
        return _queryOnlineById.toString();
      };

      return queryOnlineById;
    }(function (id) {
      var that = this;
      queryOnlineById(id).then(function (res) {
        if (res.success) {
          that.online = res.code;
        }
      });
    }),
    loadData: function loadData(id) {
      var that = this;
      var params = {
        siteId: id
      }; //查询条件

      this.loading = true;
      that.dataSource = [];
      getAction(this.url.list, params).then(function (res) {
        if (res.success) {
          if (res.result) {
            var obj = res.result.data;
            that.inletStatus = res.result.inletStatus;
            that.outletStatus = res.result.outletStatus;
            that.dataSource = [{
              name: 'COD',
              inValue: obj.e102.value,
              inStatus: obj.e102.status,
              outValue: obj.e202.value,
              outStatus: obj.e202.status,
              unit: 'mg/L'
            }, {
              name: '氨氮',
              inValue: obj.e103.value,
              inStatus: obj.e103.status,
              outValue: obj.e203.value,
              outStatus: obj.e203.status,
              unit: 'mg/L'
            }, {
              name: '总磷',
              inValue: obj.e104.value,
              inStatus: obj.e104.status,
              outValue: obj.e204.value,
              outStatus: obj.e204.status,
              unit: 'mg/L'
            }, {
              name: '总氮',
              inValue: obj.e105.value,
              inStatus: obj.e105.status,
              outValue: obj.e232.value,
              outStatus: obj.e232.status,
              unit: 'mg/L'
            }, {
              name: 'PH',
              inValue: obj.e106.value,
              inStatus: obj.e106.status,
              outValue: obj.e205.value,
              outStatus: obj.e205.status,
              unit: '一'
            }, {
              name: 'SS',
              inValue: obj.e130.value,
              inStatus: obj.e130.status,
              outValue: obj.e230.value,
              outStatus: obj.e230.status,
              unit: 'mg/L'
            }, {
              name: '温度',
              inValue: obj.e131.value,
              inStatus: obj.e131.status,
              outValue: obj.e231.value,
              outStatus: obj.e231.status,
              unit: '℃'
            }, {
              name: '瞬时流量',
              inValue: obj.e132.value,
              inStatus: obj.e132.status,
              outValue: obj.e233.value,
              outStatus: obj.e233.status,
              unit: 'L/s'
            }, {
              name: '总流量',
              inValue: obj.e101.value,
              inStatus: obj.e101.status,
              outValue: obj.e201.value,
              outStatus: obj.e201.status,
              unit: 'm³'
            }];
          }
        } else {
          that.$message.warning('系统异常=>' + res.message);
        }

        that.loading = false;
      });
    },
    onChange: function onChange(checkedValues) {
      this.getSite(checkedValues.join(','));
    },
    getSite: function getSite(st) {
      var _this3 = this;

      var params = {
        st: st
      }; // 污水站点

      querySiteBySt(params).then(function (res) {
        if (res) {
          var markers = [];
          var windows = [];
          var that = _this3;
          res.result.forEach(function (item, index) {
            var bgColor = '';

            switch (item.st) {
              case '21':
                bgColor = '#5CBB44';
                break;

              case '22':
                bgColor = '#D52B2B';
                break;

              case '52':
                bgColor = '#DD9222';
                break;

              case '53':
                bgColor = '#DD9222';
                break;
            }

            if (item.onlineStatus) {
              bgColor = 'green';
            }

            var mg = 0;

            if (item.id == 9) {
              mg = '-30px';
            }

            var width = "110px";

            if (item.id == 9 || item.id == 10 || item.id == 11) {
              width = '60px';
            }

            markers.push({
              id: item.id,
              position: [item.longitude, item.latitude],
              title: item.name,
              content: "<div style='background-color:" + bgColor + ";margin-left:" + mg + ";color:#ffffff;padding:5px;width:" + width + ";font-size:12px;text-align: center;border-radius:5px'>" + item.name + '</div>',
              //内容
              events: {
                click: function click() {
                  that.windows.forEach(function (window) {
                    window.visible = false; //关闭窗体
                  });
                  that.window = that.windows[index];
                  that.$nextTick(function () {
                    that.mainRealtime(item.id);
                    that.window.visible = true; //点击点坐标，出现信息窗体
                    // that.getSiteInfo(item.id)
                    // that.queryOnlineById(item.id)
                    // that.loadData(item.id)
                  });
                }
              }
            });
            windows.push({
              position: [item.longitude, item.latitude],
              offset: [65, -30],
              //窗体偏移
              visible: false,
              //初始是否显示
              siteName: item.name,
              onlineStatus: item.onlineStatus,
              siteId: item.id
            });
          }); //  加点

          _this3.markers = markers; //加弹窗

          _this3.windows = windows;
        }
      });
    },
    getSiteInfo: function getSiteInfo(id) {
      var that = this;
      var params = {
        id: id
      };
      querySiteById(params).then(function (res) {
        if (res.success) {
          that.siteInfo = res.result;
        }
      });
    },
    positionSite: function positionSite(id) {
      var _this4 = this;

      this.markers.forEach(function (v, i) {
        if (v.id == id) {
          _this4.center = v.position;
          _this4.zoom = 13;
        }
      });
    }
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();

      if (ids[0] && ids[0] == 1) {
        // 根据站点id
        this.positionSite(ids[1]);
      } else {// 根据区域id
        // if (ids[1] == 57) {
        //   //是否选择了雅安市
        //   this.center = [103.003398, 29.981831]
        //   this.zoom = 9
        // } else {
        // }
      }
    }
  }
};